export default __webpack_public_path__ + "static/current-gen-2c7d34e1258b9d33513f624e9921f9f4.png";